enum MeetingMessageButtonEntrySource {
    LVConversation = 0,
    LVMessage = 1,
    LVCalendarItems = 2,
    RPCalendarCard = 3,
}
export default MeetingMessageButtonEntrySource;
